import React from 'react'
import {MuiThemeProvider, createTheme} from '@material-ui/core/styles'
import Main from 'containers/Main'

const theme = createTheme({
	palette: {
		type: 'light',
		primary: {
			main: '#415dd4',
			contrastText: '#FFF'
		},
		secondary: {
			main: '#d45b4a',
			contrastText: '#FFF'
		},
		success: {
			main: '#4cae4c',
			contrastText: '#FFF'
		},
		text: {
			primary: '#4a4a4a'
		}
	},
	overrides: {
        MuiButton: {
            root: {
                letterSpacing: '2px',
                fontSize: '12px',
                lineHeight: 'normal',
                height: '35px',
                borderRadius: '2px',
                minWidth: '140px'
            }
        },
        MuiDialogContent: {
            root: {
                padding: '20px 40px'
            }
        },
        MuiDialogTitle: {
            root: {
                padding: '40px 40px 20px 40px'
            }
        },
        MuiDialogActions: {
            root: {
                padding: '20px 40px 40px 40px',
                margin: 0
            }
        },
		MuiCheckbox: {
			root: {
				'&:hover': {
					backgroundColor: 'transparent'
				}
			},
			colorPrimary: {
				'&$checked': {
					'&:hover': {
						backgroundColor: 'transparent'
					}
				}
			}
		},
		MuiFormControlLabel: {
			label: {
				color: '#4a4a4a',
				fontWeight: 700,
				fontSize: '13.5px',
			}
		}
	},
	typography: {
		useNextVariants: true,
		fontFamily: [
			'Helvetica Neue',
			'Arial',
			'sans-serif'
		].join(',')
	}
})

const App =  () => (
	<MuiThemeProvider theme={theme}>
		<Main />
	</MuiThemeProvider>
)

export default App
